var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvice = function SvgAdvice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M12.5 14.5v-2.83m-5 .03v2.8l-5 1.79a3 3 0 0 0-2 2.82v2.39h11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M9.99 12.5c2.762 0 5-2.686 5-6s-2.238-6-5-6-5 2.686-5 6 2.239 6 5 6Zm8.51 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.5 16a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    x: 18,
    y: 18,
    fill: "currentColor",
    rx: 0.5
  })));
};
export default SvgAdvice;